export default __webpack_public_path__ + "static/media/gold-7.7d580637.png";